import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import "../../Cyclone/DisturbanceTrack/DisturbanceTrack.css";
import DailySituationReport from "./DailySituationReport";
import DsrBulkTemplate from "./DsrBulkTemplate";
import AcpDataReport from "./AcpDataReport";

const TABS = [
    { id: "report", label: "Report" },
    { id: "bulk", label: "Upload" },
    { id: "acp", label: "Data View" },
];

const SituationReportHub = () => {
    const [searchParams] = useSearchParams();
    const initialTab = TABS.some((tab) => tab.id === searchParams.get("tab"))
        ? searchParams.get("tab")
        : "report";
    const [activeSection, setActiveSection] = useState(initialTab);

    return (
        <div style={{ marginBottom: "1rem" }}>
            <div className="section-buttons-container" style={{ border: "0px" }}>
                {TABS.map((tab) => (
                    <button
                        key={tab.id}
                        className={`section-button ${activeSection === tab.id ? "active" : ""}`}
                        onClick={() => setActiveSection(tab.id)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            <div className="section-content-container">
                <div className={`section-container ${activeSection === "report" ? "active-section" : "hidden-section"}`}>
                    <DailySituationReport />
                </div>
                <div className={`section-container ${activeSection === "bulk" ? "active-section" : "hidden-section"}`}>
                    <DsrBulkTemplate />
                </div>
                <div className={`section-container ${activeSection === "acp" ? "active-section" : "hidden-section"}`}>
                    <AcpDataReport />
                </div>
            </div>
        </div>
    );
};

export default SituationReportHub;
